import {
  GET_COURSES_URL,
  GET_ALL_BOARDS_URL,
  GET_ALL_CLASS_NAMES_URL,
  GET_ALL_BOARDS_URL_INSTITUTION,
  GET_ALL_CLASS_NAMES_URL_INSTITUTION,
  GET_ALL_BOARDS_URL_TEACHER,
  GET_ALL_CLASS_NAMES_URL_TEACHER,
  GET_ALL_SUBJECTS_URL,
  GET_ALL_TOPICS_URL,
  GET_ALL_SUBTOPICS_URL,
  GET_PAGES_FOR_COURSE_URL,
  GET_PAGES_FOR_SUBJECT_URL,
  GET_PAGES_FOR_TOPIC_URL,
  GET_PAGES_FOR_SUBTOPIC_URL,
  GET_PAGE_FOR_COURSE_URL,
  GET_PAGE_FOR_SUBJECT_URL,
  GET_PAGE_FOR_TOPIC_URL,
  GET_PAGE_FOR_SUBTOPIC_URL,
  UPDATE_PAGE_FOR_COURSE_URL,
  UPDATE_PAGE_FOR_SUBJECT_URL,
  UPDATE_PAGE_FOR_TOPIC_URL,
  UPDATE_PAGE_FOR_SUBTOPIC_URL,
  DELETE_PAGE_FOR_COURSE_URL,
  DELETE_PAGE_FOR_SUBJECT_URL,
  DELETE_PAGE_FOR_TOPIC_URL,
  DELETE_PAGE_FOR_SUBTOPIC_URL,
  ADD_SUBJECT_URL,
  UPDATE_SUBJECT_URL,
  DELETE_SUBJECT_URL,
  ADD_TOPIC_URL,
  UPDATE_TOPIC_URL,
  DELETE_TOPIC_URL,
  ADD_SUBTOPIC_URL,
  UPDATE_SUBTOPIC_URL,
  DELETE_SUBTOPIC_URL,
  CREATE_PAGE_FOR_COURSE_URL,
  CREATE_PAGE_FOR_SUBJECT_URL,
  CREATE_PAGE_FOR_TOPIC_URL,
  CREATE_PAGE_FOR_SUBTOPIC_URL,
  UPDATE_SEQUENCE_FOR_COURSE_URL,
  UPDATE_SEQUENCE_FOR_SUBJECT_URL,
  UPDATE_SEQUENCE_FOR_TOPIC_URL,
  UPDATE_SEQUENCE_FOR_SUBTOPIC_URL,
  ADD_COURSE_URL,
  UPDATE_COURSE_URL,
  DELETE_COURSE_URL,
  GET_BREADCRUMB_URL,
  GET_BREADCRUMB_URL_TEACHER,
  CREATE_PAGE_FOR_COURSE_URL_INSTITUTION,
  UPDATE_PAGE_FOR_COURSE_URL_INSTITUTION,
  DELETE_PAGE_FOR_COURSE_URL_INSTITUTION,
  GET_PAGE_FOR_COURSE_URL_INSTITUTION,
  GET_SINGLE_PAGE_FOR_COURSE_URL_INSTITUTION,
  CREATE_PAGE_FOR_SUBJECT_URL_INSTITUTION,
  UPDATE_PAGE_FOR_SUBJECT_URL_INSTITUTION,
  DELETE_PAGE_FOR_SUBJECT_URL_INSTITUTION,
  GET_PAGE_FOR_SUBJECT_URL_INSTITUTION,
  GET_SINGLE_PAGE_FOR_SUBJECT_URL_INSTITUTION,
  CREATE_PAGE_FOR_TOPIC_URL_INSTITUTION,
  UPDATE_PAGE_FOR_TOPIC_URL_INSTITUTION,
  DELETE_PAGE_FOR_TOPIC_URL_INSTITUTION,
  GET_PAGES_FOR_TOPIC_URL_INSTITUTION,
  GET_SINGLE_PAGE_FOR_TOPIC_URL_INSTITUTION,
  CREATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION,
  UPDATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION,
  DELETE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION,
  GET_PAGE_FOR_SUBTOPIC_URL_INSTITUTION,
  GET_SINGLE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION,
  GET_COURSES_URL_INSTITUTION,
  GET_ALL_TEACHER_COURSE_URL,
  GET_SUBJECTS_URL_INSTITUTION,
  GET_TOPICS_URL_INSTITUTION,
  GET_SUBTOPIC_URL_INSTITUTION,
  GET_ADMIN_COURSE_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_TOPIC_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SINGLE_COURSE_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SINGLE_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SINGLE_TOPIC_PAGE_CONTENT_FOR_INSTITUTION,
  GET_ADMIN_SINGLE_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION,
  GENERATE_AUDIO_BOOK,
  UPLOAD_PAGE_CONTENT_FILE_URL,
  REMOVE_PAGE_CONTENT_FILE_URL,
  UPLOAD_PAGE_CONTENT_FILE_URL_INSTITUTION,
  REMOVE_PAGE_CONTENT_FILE_URL_INSTITUTION,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

const isInstitutionRole = () => {
  const role = Cookies.get("role");
  return role === "institution" || role === "teacher";
};

const getAuthToken = () => {
  if (isInstitutionRole()) {
    return Cookies.get("institution_token");
  }
  return Cookies.get("admin_token");
};

const getHeaders = (includeContentType = true) => {
  const headers = {};
  if (includeContentType) {
    headers["Content-Type"] = "application/json";
  }
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getCourses = async (search = "", board = "", className = "") => {
  try {
    const role = Cookies.get("role");
    let baseUrl =
      role === "teacher" || role === "institution"
        ? GET_ALL_TEACHER_COURSE_URL
        : GET_COURSES_URL;

    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (board) params.append("board", board);
    if (className) params.append("class_name", className);

    const queryString = params.toString();
    if (queryString) {
      baseUrl += `?${queryString}`;
    }

    const response = await fetch(baseUrl, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};

export const getBoards = async (isCourse = true, filters = {}) => {
  try {
    const role = Cookies.get("role");
    let url =
      role === "teacher"
        ? GET_ALL_BOARDS_URL_TEACHER
        : role === "institution"
        ? GET_ALL_BOARDS_URL_INSTITUTION
        : GET_ALL_BOARDS_URL;

    const params = new URLSearchParams();
    if (isCourse !== null && isCourse !== undefined) {
      params.set("is_course", String(isCourse));
    }
    if (typeof filters.is_institution === "boolean") {
      params.set("is_institution", String(filters.is_institution));
    }
    if (params.toString()) url += `?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });
    if (!response.ok) return [];
    return await response.json();
  } catch (error) {
    console.error("Error fetching boards:", error);
    return [];
  }
};

export const getClassNames = async () => {
  try {
    const role = Cookies.get("role");
    let url =
      role === "teacher"
        ? GET_ALL_CLASS_NAMES_URL_TEACHER
        : role === "institution"
        ? GET_ALL_CLASS_NAMES_URL_INSTITUTION
        : GET_ALL_CLASS_NAMES_URL;

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });
    if (!response.ok) return [];
    return await response.json();
  } catch (error) {
    console.error("Error fetching class names:", error);
    return [];
  }
};

export const addCourse = async (courseData) => {
  try {
    const response = await fetch(ADD_COURSE_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(courseData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding course:", error);
    throw error;
  }
};

export const updateCourse = async (courseData) => {
  try {
    const { key, ...dataWithoutKey } = courseData;

    const response = await fetch(
      `${UPDATE_COURSE_URL}?key=${encodeURIComponent(key)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify(dataWithoutKey),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating course:", error);
    throw error;
  }
};

export const deleteCourse = async (courseKey) => {
  try {
    const response = await fetch(
      `${DELETE_COURSE_URL}?key=${encodeURIComponent(courseKey)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting course:", error);
    throw error;
  }
};

export const getSubjectsByCourseKey = async (courseKey) => {
  try {
    const baseUrl = isInstitutionRole()
      ? GET_SUBJECTS_URL_INSTITUTION
      : GET_ALL_SUBJECTS_URL;
    const response = await fetch(
      `${baseUrl}?course_key=${encodeURIComponent(courseKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};

export const getTopicsBySubjectKey = async (subjectKey) => {
  try {
    const baseUrl = isInstitutionRole()
      ? GET_TOPICS_URL_INSTITUTION
      : GET_ALL_TOPICS_URL;
    const response = await fetch(
      `${baseUrl}?subject_key=${encodeURIComponent(subjectKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching topics:", error);
    throw error;
  }
};

export const getSubtopicsByTopicKey = async (topicKey) => {
  try {
    const baseUrl = isInstitutionRole()
      ? GET_SUBTOPIC_URL_INSTITUTION
      : GET_ALL_SUBTOPICS_URL;
    const response = await fetch(
      `${baseUrl}?topic_key=${encodeURIComponent(topicKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching subtopics:", error);
    throw error;
  }
};

export const getPagesForCourse = async (courseKey) => {
  try {
    if (isInstitutionRole()) {
      const [instResponse, adminResponse] = await Promise.all([
        fetch(
          `${GET_PAGE_FOR_COURSE_URL_INSTITUTION}?course_key=${encodeURIComponent(
            courseKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
        fetch(
          `${GET_ADMIN_COURSE_PAGE_CONTENT_FOR_INSTITUTION}?course_key=${encodeURIComponent(
            courseKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
      ]);

      if (!instResponse.ok || !adminResponse.ok) {
        throw new Error(
          `HTTP error! status: inst=${instResponse.status}, admin=${adminResponse.status}`,
        );
      }

      const instData = await instResponse.json();
      const adminData = await adminResponse.json();

      const mapInstPage = (p) => ({
        ...p,
        is_admin_page: false,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapInstPage)
          : p.child_pages,
      });
      const mapAdminPage = (p) => ({
        ...p,
        is_admin_page: true,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapAdminPage)
          : p.child_pages,
      });

      const instPages = Array.isArray(instData)
        ? instData.map(mapInstPage)
        : [];
      const adminPages = Array.isArray(adminData)
        ? adminData.map(mapAdminPage)
        : [];

      return [...adminPages, ...instPages];
    }

    const response = await fetch(
      `${GET_PAGES_FOR_COURSE_URL}?course_key=${encodeURIComponent(courseKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching pages for course:", error);
    throw error;
  }
};

export const getPagesForSubject = async (subjectKey) => {
  try {
    if (isInstitutionRole()) {
      const [instResponse, adminResponse] = await Promise.all([
        fetch(
          `${GET_PAGE_FOR_SUBJECT_URL_INSTITUTION}?subject_key=${encodeURIComponent(
            subjectKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
        fetch(
          `${GET_ADMIN_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION}?subject_key=${encodeURIComponent(
            subjectKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
      ]);

      if (!instResponse.ok || !adminResponse.ok) {
        throw new Error(
          `HTTP error! status: inst=${instResponse.status}, admin=${adminResponse.status}`,
        );
      }

      const instData = await instResponse.json();
      const adminData = await adminResponse.json();

      const mapInstPage = (p) => ({
        ...p,
        is_admin_page: false,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapInstPage)
          : p.child_pages,
      });
      const mapAdminPage = (p) => ({
        ...p,
        is_admin_page: true,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapAdminPage)
          : p.child_pages,
      });

      const instPages = Array.isArray(instData)
        ? instData.map(mapInstPage)
        : [];
      const adminPages = Array.isArray(adminData)
        ? adminData.map(mapAdminPage)
        : [];

      return [...adminPages, ...instPages];
    }

    const response = await fetch(
      `${GET_PAGES_FOR_SUBJECT_URL}?subject_key=${encodeURIComponent(
        subjectKey,
      )}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching pages for subject:", error);
    throw error;
  }
};

export const getPagesForTopic = async (topicKey) => {
  try {
    if (isInstitutionRole()) {
      const [instResponse, adminResponse] = await Promise.all([
        fetch(
          `${GET_PAGES_FOR_TOPIC_URL_INSTITUTION}?topic_key=${encodeURIComponent(
            topicKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
        fetch(
          `${GET_ADMIN_TOPIC_PAGE_CONTENT_FOR_INSTITUTION}?topic_key=${encodeURIComponent(
            topicKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
      ]);

      if (!instResponse.ok || !adminResponse.ok) {
        throw new Error(
          `HTTP error! status: inst=${instResponse.status}, admin=${adminResponse.status}`,
        );
      }

      const instData = await instResponse.json();
      const adminData = await adminResponse.json();

      const mapInstPage = (p) => ({
        ...p,
        is_admin_page: false,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapInstPage)
          : p.child_pages,
      });
      const mapAdminPage = (p) => ({
        ...p,
        is_admin_page: true,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapAdminPage)
          : p.child_pages,
      });

      const instPages = Array.isArray(instData)
        ? instData.map(mapInstPage)
        : [];
      const adminPages = Array.isArray(adminData)
        ? adminData.map(mapAdminPage)
        : [];

      return [...adminPages, ...instPages];
    }

    const response = await fetch(
      `${GET_PAGES_FOR_TOPIC_URL}?topic_key=${encodeURIComponent(topicKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching pages for topic:", error);
    throw error;
  }
};

export const getPagesForSubtopic = async (subtopicKey) => {
  try {
    if (isInstitutionRole()) {
      const [instResponse, adminResponse] = await Promise.all([
        fetch(
          `${GET_PAGE_FOR_SUBTOPIC_URL_INSTITUTION}?subtopic_key=${encodeURIComponent(
            subtopicKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
        fetch(
          `${GET_ADMIN_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION}?subtopic_key=${encodeURIComponent(
            subtopicKey,
          )}`,
          {
            method: "GET",
            headers: getHeaders(),
          },
        ),
      ]);

      if (!instResponse.ok || !adminResponse.ok) {
        throw new Error(
          `HTTP error! status: inst=${instResponse.status}, admin=${adminResponse.status}`,
        );
      }

      const instData = await instResponse.json();
      const adminData = await adminResponse.json();

      const mapInstPage = (p) => ({
        ...p,
        is_admin_page: false,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapInstPage)
          : p.child_pages,
      });
      const mapAdminPage = (p) => ({
        ...p,
        is_admin_page: true,
        child_pages: Array.isArray(p.child_pages)
          ? p.child_pages.map(mapAdminPage)
          : p.child_pages,
      });

      const instPages = Array.isArray(instData)
        ? instData.map(mapInstPage)
        : [];
      const adminPages = Array.isArray(adminData)
        ? adminData.map(mapAdminPage)
        : [];

      return [...adminPages, ...instPages];
    }

    const response = await fetch(
      `${GET_PAGES_FOR_SUBTOPIC_URL}?subtopic_key=${encodeURIComponent(
        subtopicKey,
      )}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching pages for subtopic:", error);
    throw error;
  }
};

export const getPageForCourse = async (
  courseKey,
  pageId,
  level,
  isAdminPage = false,
) => {
  try {
    const levelQuery = level ? `&level=${encodeURIComponent(level)}` : "";
    let url;
    if (isInstitutionRole()) {
      const baseUrl = isAdminPage
        ? GET_ADMIN_SINGLE_COURSE_PAGE_CONTENT_FOR_INSTITUTION
        : GET_SINGLE_PAGE_FOR_COURSE_URL_INSTITUTION;
      url = `${baseUrl}?course_key=${encodeURIComponent(
        courseKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    } else {
      url = `${GET_PAGE_FOR_COURSE_URL}?course_key=${encodeURIComponent(
        courseKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for course:", error);
    throw error;
  }
};

export const getPageForSubject = async (
  subjectKey,
  pageId,
  level,
  isAdminPage = false,
) => {
  try {
    const levelQuery = level ? `&level=${encodeURIComponent(level)}` : "";
    let url;
    if (isInstitutionRole()) {
      const baseUrl = isAdminPage
        ? GET_ADMIN_SINGLE_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION
        : GET_SINGLE_PAGE_FOR_SUBJECT_URL_INSTITUTION;
      url = `${baseUrl}?subject_key=${encodeURIComponent(
        subjectKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    } else {
      url = `${GET_PAGE_FOR_SUBJECT_URL}?subject_key=${encodeURIComponent(
        subjectKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for subject:", error);
    throw error;
  }
};

export const getPageForTopic = async (
  topicKey,
  pageId,
  level,
  isAdminPage = false,
) => {
  try {
    const levelQuery = level ? `&level=${encodeURIComponent(level)}` : "";
    let url;
    if (isInstitutionRole()) {
      const baseUrl = isAdminPage
        ? GET_ADMIN_SINGLE_TOPIC_PAGE_CONTENT_FOR_INSTITUTION
        : GET_SINGLE_PAGE_FOR_TOPIC_URL_INSTITUTION;
      url = `${baseUrl}?topic_key=${encodeURIComponent(
        topicKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    } else {
      url = `${GET_PAGE_FOR_TOPIC_URL}?topic_key=${encodeURIComponent(
        topicKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getPageForSubtopic = async (
  subtopicKey,
  pageId,
  level,
  isAdminPage = false,
) => {
  console.log("isAdminPage", isAdminPage);

  try {
    const levelQuery = level ? `&level=${encodeURIComponent(level)}` : "";
    let url;
    if (isInstitutionRole()) {
      const baseUrl = isAdminPage
        ? GET_ADMIN_SINGLE_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION
        : GET_SINGLE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION;
      url = `${baseUrl}?subtopic_key=${encodeURIComponent(
        subtopicKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    } else {
      url = `${GET_PAGE_FOR_SUBTOPIC_URL}?subtopic_key=${encodeURIComponent(
        subtopicKey,
      )}&id=${encodeURIComponent(pageId)}${levelQuery}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for subtopic:", error);
    throw error;
  }
};

export const addSubject = async (subjectData) => {
  try {
    const response = await fetch(ADD_SUBJECT_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(subjectData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding subject:", error);
    throw error;
  }
};

export const updateSubject = async (subjectData) => {
  try {
    const response = await fetch(
      `${UPDATE_SUBJECT_URL}?key=${encodeURIComponent(subjectData.key)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: subjectData.name,
          total_number_quizes: subjectData.total_number_quizes,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating subject:", error);
    throw error;
  }
};

export const deleteSubject = async (subjectKey) => {
  try {
    const response = await fetch(
      `${DELETE_SUBJECT_URL}?key=${encodeURIComponent(subjectKey)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting subject:", error);
    throw error;
  }
};

export const addTopic = async (topicData) => {
  try {
    const response = await fetch(ADD_TOPIC_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(topicData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding topic:", error);
    throw error;
  }
};

export const updateTopic = async (topicData) => {
  try {
    const response = await fetch(
      `${UPDATE_TOPIC_URL}?key=${encodeURIComponent(topicData.key)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: topicData.name,
          total_number_quizes: topicData.total_number_quizes,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating topic:", error);
    throw error;
  }
};

export const deleteTopic = async (topicKey) => {
  try {
    const response = await fetch(
      `${DELETE_TOPIC_URL}?key=${encodeURIComponent(topicKey)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting topic:", error);
    throw error;
  }
};

export const addSubtopic = async (subtopicData) => {
  try {
    const response = await fetch(ADD_SUBTOPIC_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(subtopicData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding subtopic:", error);
    throw error;
  }
};

export const updateSubtopic = async (subtopicData) => {
  try {
    const response = await fetch(
      `${UPDATE_SUBTOPIC_URL}?key=${encodeURIComponent(subtopicData.key)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: subtopicData.name,
          total_number_quizes: subtopicData.total_number_quizes,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating subtopic:", error);
    throw error;
  }
};

export const deleteSubtopic = async (subtopicKey) => {
  try {
    const response = await fetch(
      `${DELETE_SUBTOPIC_URL}?key=${encodeURIComponent(subtopicKey)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting subtopic:", error);
    throw error;
  }
};

export const createPageForCourse = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? CREATE_PAGE_FOR_COURSE_URL_INSTITUTION
      : CREATE_PAGE_FOR_COURSE_URL;
    const response = await fetch(baseUrl, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(pageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating page for course:", error);
    throw error;
  }
};

export const createPageForSubject = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? CREATE_PAGE_FOR_SUBJECT_URL_INSTITUTION
      : CREATE_PAGE_FOR_SUBJECT_URL;
    const response = await fetch(baseUrl, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(pageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating page for subject:", error);
    throw error;
  }
};

export const createPageForTopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? CREATE_PAGE_FOR_TOPIC_URL_INSTITUTION
      : CREATE_PAGE_FOR_TOPIC_URL;
    const response = await fetch(baseUrl, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(pageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating page for topic:", error);
    throw error;
  }
};

export const createPageForSubtopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? CREATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION
      : CREATE_PAGE_FOR_SUBTOPIC_URL;
    const response = await fetch(baseUrl, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(pageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating page for subtopic:", error);
    throw error;
  }
};

export const updatePageForCourse = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_COURSE_URL_INSTITUTION
      : UPDATE_PAGE_FOR_COURSE_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          ...(pageData.content !== undefined && { content: pageData.content }),
          ...(pageData.medium_content !== undefined && {
            medium_content: pageData.medium_content,
          }),
          ...(pageData.hard_content !== undefined && {
            hard_content: pageData.hard_content,
          }),
          ...(pageData.context !== undefined && { context: pageData.context }),
          ...(pageData.eval !== undefined && { eval: pageData.eval }),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page for course:", error);
    throw error;
  }
};

export const updatePageForSubject = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_SUBJECT_URL_INSTITUTION
      : UPDATE_PAGE_FOR_SUBJECT_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          ...(pageData.content !== undefined && { content: pageData.content }),
          ...(pageData.medium_content !== undefined && {
            medium_content: pageData.medium_content,
          }),
          ...(pageData.hard_content !== undefined && {
            hard_content: pageData.hard_content,
          }),
          ...(pageData.context !== undefined && { context: pageData.context }),
          ...(pageData.eval !== undefined && { eval: pageData.eval }),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page for subject:", error);
    throw error;
  }
};

export const updatePageForTopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_TOPIC_URL_INSTITUTION
      : UPDATE_PAGE_FOR_TOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          ...(pageData.content !== undefined && { content: pageData.content }),
          ...(pageData.medium_content !== undefined && {
            medium_content: pageData.medium_content,
          }),
          ...(pageData.hard_content !== undefined && {
            hard_content: pageData.hard_content,
          }),
          ...(pageData.context !== undefined && { context: pageData.context }),
          ...(pageData.eval !== undefined && { eval: pageData.eval }),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page for topic:", error);
    throw error;
  }
};

export const updatePageForSubtopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION
      : UPDATE_PAGE_FOR_SUBTOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          ...(pageData.content !== undefined && { content: pageData.content }),
          ...(pageData.medium_content !== undefined && {
            medium_content: pageData.medium_content,
          }),
          ...(pageData.hard_content !== undefined && {
            hard_content: pageData.hard_content,
          }),
          ...(pageData.context !== undefined && { context: pageData.context }),
          ...(pageData.eval !== undefined && { eval: pageData.eval }),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page for subtopic:", error);
    throw error;
  }
};

export const updatePageMetadataForCourse = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_COURSE_URL_INSTITUTION
      : UPDATE_PAGE_FOR_COURSE_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: pageData.name,
          page_type: pageData.page_type,
          ...(pageData.is_content_quiz_enabled !== undefined
            ? { is_content_quiz_enabled: pageData.is_content_quiz_enabled }
            : {}),
          ...(pageData.material_type
            ? { material_type: pageData.material_type }
            : {}),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page metadata for course:", error);
    throw error;
  }
};

export const updatePageMetadataForSubject = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_SUBJECT_URL_INSTITUTION
      : UPDATE_PAGE_FOR_SUBJECT_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: pageData.name,
          page_type: pageData.page_type,
          ...(pageData.is_content_quiz_enabled !== undefined
            ? { is_content_quiz_enabled: pageData.is_content_quiz_enabled }
            : {}),
          ...(pageData.material_type
            ? { material_type: pageData.material_type }
            : {}),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page metadata for subject:", error);
    throw error;
  }
};

export const updatePageMetadataForTopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_TOPIC_URL_INSTITUTION
      : UPDATE_PAGE_FOR_TOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: pageData.name,
          page_type: pageData.page_type,
          ...(pageData.is_content_quiz_enabled !== undefined
            ? { is_content_quiz_enabled: pageData.is_content_quiz_enabled }
            : {}),
          ...(pageData.material_type
            ? { material_type: pageData.material_type }
            : {}),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page metadata for topic:", error);
    throw error;
  }
};

export const updatePageMetadataForSubtopic = async (pageData) => {
  try {
    const baseUrl = isInstitutionRole()
      ? UPDATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION
      : UPDATE_PAGE_FOR_SUBTOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageData.id)}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          name: pageData.name,
          page_type: pageData.page_type,
          ...(pageData.is_content_quiz_enabled !== undefined
            ? { is_content_quiz_enabled: pageData.is_content_quiz_enabled }
            : {}),
          ...(pageData.material_type
            ? { material_type: pageData.material_type }
            : {}),
          ...(pageData.page_type === "test"
            ? {
                pass_percentage: pageData?.pass_percentage,
                duration: pageData?.duration,
              }
            : {}),
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating page metadata for subtopic:", error);
    throw error;
  }
};

export const updateSequenceForCourse = async (
  courseKey,
  payload,
  child,
  parentId,
) => {
  const url = child
    ? `${UPDATE_SEQUENCE_FOR_COURSE_URL}?course_key=${encodeURIComponent(
        courseKey,
      )}&parent=${parentId}`
    : `${UPDATE_SEQUENCE_FOR_COURSE_URL}?course_key=${encodeURIComponent(
        courseKey,
      )}`;
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating sequence for course:", error);
    throw error;
  }
};

export const updateSequenceForSubject = async (
  subjectKey,
  payload,
  child,
  parentId,
) => {
  const url = child
    ? `${UPDATE_SEQUENCE_FOR_SUBJECT_URL}?subject_key=${encodeURIComponent(
        subjectKey,
      )}&parent=${parentId}`
    : `${UPDATE_SEQUENCE_FOR_SUBJECT_URL}?subject_key=${encodeURIComponent(
        subjectKey,
      )}`;
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating sequence for subject:", error);
    throw error;
  }
};

export const updateSequenceForTopic = async (
  topicKey,
  payload,
  child,
  parentId,
) => {
  try {
    const url = child
      ? `${UPDATE_SEQUENCE_FOR_TOPIC_URL}?topic_key=${encodeURIComponent(
          topicKey,
        )}&parent=${parentId}`
      : `${UPDATE_SEQUENCE_FOR_TOPIC_URL}?topic_key=${encodeURIComponent(
          topicKey,
        )}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating sequence for topic:", error);
    throw error;
  }
};

export const updateSequenceForSubtopic = async (
  subtopicKey,
  payload,
  child,
  parentId,
) => {
  try {
    const url = child
      ? `${UPDATE_SEQUENCE_FOR_SUBTOPIC_URL}?subtopic_key=${encodeURIComponent(
          subtopicKey,
        )}&parent=${parentId}`
      : `${UPDATE_SEQUENCE_FOR_SUBTOPIC_URL}?subtopic_key=${encodeURIComponent(
          subtopicKey,
        )}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating sequence for subtopic:", error);
    throw error;
  }
};

export const deletePageForCourse = async (pageId) => {
  try {
    const baseUrl = isInstitutionRole()
      ? DELETE_PAGE_FOR_COURSE_URL_INSTITUTION
      : DELETE_PAGE_FOR_COURSE_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageId)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting page for course:", error);
    throw error;
  }
};

export const deletePageForSubject = async (pageId) => {
  try {
    const baseUrl = isInstitutionRole()
      ? DELETE_PAGE_FOR_SUBJECT_URL_INSTITUTION
      : DELETE_PAGE_FOR_SUBJECT_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageId)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting page for subject:", error);
    throw error;
  }
};

export const deletePageForTopic = async (pageId) => {
  try {
    const baseUrl = isInstitutionRole()
      ? DELETE_PAGE_FOR_TOPIC_URL_INSTITUTION
      : DELETE_PAGE_FOR_TOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageId)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting page for topic:", error);
    throw error;
  }
};

export const deletePageForSubtopic = async (pageId) => {
  try {
    const baseUrl = isInstitutionRole()
      ? DELETE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION
      : DELETE_PAGE_FOR_SUBTOPIC_URL;
    const response = await fetch(
      `${baseUrl}?id=${encodeURIComponent(pageId)}`,
      {
        method: "DELETE",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting page for subtopic:", error);
    throw error;
  }
};

export const getBreadcrumps = async (courseKey) => {
  try {
    const role = Cookies.get("role");
    const baseUrl =
      role === "teacher" || role === "institution"
        ? GET_BREADCRUMB_URL_TEACHER
        : GET_BREADCRUMB_URL;
    const response = await fetch(
      `${baseUrl}?course_key=${encodeURIComponent(courseKey)}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching breadcrumbs:", error);
    throw error;
  }
};

export const generateAudioBook = async (id, layer) => {
  const keyfield =
    layer === "course"
      ? "courseId"
      : layer === "subject"
        ? "subjectId"
        : layer === "topic"
          ? "topicId"
          : "subtopicId";

  try {
    const response = await fetch(`${GENERATE_AUDIO_BOOK}?${keyfield}=${id}`, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching breadcrumbs:", error);
    throw error;
  }
};

export const uploadPageContentFile = async (payload) => {
  try {
    const formData = new FormData();

    formData.append("title", payload.title);
    formData.append("key", payload.key);
    formData.append("pageid", payload.pageid);
    formData.append("type", payload.type);
    formData.append("url", payload.url);
    formData.append("name", payload.name);

    if (payload.file instanceof File) {
      formData.append("file", payload.file);
    } else if (typeof payload.file === "string") {
      formData.append("file", payload.file);
    }

    const url = isInstitutionRole()
      ? UPLOAD_PAGE_CONTENT_FILE_URL_INSTITUTION
      : UPLOAD_PAGE_CONTENT_FILE_URL;

    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(false),
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const removePageContentFile = async (payload) => {
  try {
    const url = isInstitutionRole()
      ? REMOVE_PAGE_CONTENT_FILE_URL_INSTITUTION
      : REMOVE_PAGE_CONTENT_FILE_URL;

    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error removing file:", error);
    throw error;
  }
};
